import "../styles/home.css";

export default function Footer() {
  return (
    <footer className="hsyc hsyc-footer">
      <div className="hsyc-wrap">
        <p>© 2026 Houston Sikh Youth Camp</p>
        <p>Sangat, seva, simran</p>
      </div>
    </footer>
  );
}
